import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  NavbarText,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  
  const toggle = () => setIsOpen(!isOpen);


  return (
    <Navbar expand="md" color="light" light>
      <NavbarBrand href='/'><h3>Wocons</h3></NavbarBrand>
      <NavbarToggler onClick={toggle} />
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ms-auto" navbar>
             <NavItem>
                <NavLink href="/productConfigurator">Web Product configurator</NavLink>
              </NavItem>
       
        </Nav>

       
       
      </Collapse>
    </Navbar>
  );
}

export default Header;